// webview에서 rn으로 값을 송신하는 함수
export const postMessage = (type: string, data: any) => {
  if (!window.ReactNativeWebView) {
    // 이 값이 없는 경우 모바일이 아니다.
    return;
  }
  window.ReactNativeWebView?.postMessage(JSON.stringify({ type, data }));
};
